import type { ReactNode } from 'react';

export const symbol_airline_seat_flat_angled: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m377-479 65-179q8-23 31-33t46-2l290 105q59 21 85 77.5t5 116.5l-34 93q-5 12-15.5 17.5t-22.5.5L395-441q-12-5-17.5-15.5T377-479Zm122-158q-8 23-15.5 43.5T468-551l-24 64 55-150Zm287 467L91-424q-11-5-17-16t-1-22q5-12 16-17.5t22-.5l696 253q12 5 17 15.5t1 22.5q-5 12-16 18t-23 1ZM173-533q-35-35-35-85t35-85q35-35 85-35t85 35q35 35 35 85t-35 85q-35 35-85 35t-85-35Zm127.5-42.5Q318-593 318-618t-17.5-42.5Q283-678 258-678t-42.5 17.5Q198-643 198-618t17.5 42.5Q233-558 258-558t42.5-17.5ZM444-487l375 137 24-65q13-35-3.5-69.5T788-532L499-637l-55 150ZM258-618Z"
		/>
	</svg>
);
